exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact-list-label[data-v-548cbf20]:hover {\n    background-color: #f0f0f0;\n}\n", ""]);

// exports
